export const isSobField = (field: string) => {
  return field.endsWith('Sob')
}
